import error from "../../../common/nodejs/errors";

// AT表データ
export const COMP_ERR = "status_error";

// AT項目翻訳ファイルの親子関係があるデータのタイトル/説明データID
export const I18N_PARENT_ID = "999998";

/** API type定義 */
export const API_TYPE = {
  CONFIRM: "confirm",
  READ: "read",
  STANDBY: "standby",
  START: "start",
  STOP: "stop",
  TERMINATE: "terminate",
  ERR_TERMINATE: "errorTerminate",
  MONITOR: "monitor",
};

/** ポーリング共通処理においてポーリング続行する場合に使用 */
export const POLLING_RESULT_CONTINUE = 'continue';
/** ポーリング共通処理においてポーリング終了する場合に使用 */
export const POLLING_RESULT_FINISH = 'finish';
/** ポーリング共通処理においてエラー終了する場合に使用 */
export const POLLING_RESULT_ERROR = 'error';

/** 動作状態の定義 */
export const FLOW = {
  INIT: "init", // 開始状態
  STANDBY: "standBy", // 待機
  PRE_EXECUTE: "preExe", // 実行待ち
  EXECUTE: "execute", // 実行
  CHECK_EXE: "checkExecute", // 実行監視
  STOP: "stop", // 停止
  CHECK_STOP: "checkStop", // 停止監視
  END: "end", // 終了状態◎
  WAIT_STOP: "waitStop", // 停止指示待ち状態
  ERR: "error", // 共通エラー
  ERR_COMMUNICATE: "communicationError", // 通信エラー
  ERR_STATUS: "statusError", // STATUSエラー
  ERR_NRC: "nrcError", // NRCエラー
  ERR_TIMEOUT: "timeoutError", // タイムアウトエラー
};

/** 動作状態の内、エラーに該当する状態 */
export const FLOW_ERROR = [
  FLOW.ERR,
  FLOW.ERR_COMMUNICATE,
  FLOW.ERR_STATUS,
  FLOW.ERR_NRC
];

/** AT実行API Completed時のres_type */
export const RES_TYPE = {
  OK: "ok",
  NO: "no",
  NG: "ng",
};

/** AT実行API 監視状態 */
export const MNTR_STATUS = {
  /** 継続 */
  IN_PROGRESS: "in_progress",
  /** 終了 */
  COMPLETE: "complete",
};

/** NRCエラーコード */
export const NRC_CODE = {
  X11: "11",
  X12: "12",
  X21: "21",
  X22: "22",
  X24: "24",
  X31: "31",
};

/** データタイプの定義 */
export const DATA_TYPE = {
  VAL: "Value",
  HEX: "HEX",
  FLG: "FLG",
};

/** HEX値をそのまま表示する際に、先頭に付与する文字列 */
export const HEX_PREFIX = "0x";

// エラーメッセージの種類
export const ERR_KEY = {
  // 共通エラー
  COMMON: "COMMON",
  // 通信エラー
  COMMUNICATION: "COMMUNICATION",
  // 初期化通信エラー
  INIT: "INIT",
  // STATUSエラー
  STATUS: "STATUS",
  // NRCエラー
  NRC: "NRC",
  // 停止NRCエラー
  STOP_NRC: "STOP_NRC",
  // タイムアウトエラー
  TIMEOUT: "TIMEOUT",
};

/**
 * エラーメッセージの種類に対するエラーコード
 * 現状ではCOMMONのみコードを定義する
 */
export const ERR_KEY_CODE = {
  // 共通エラー
  [ERR_KEY.COMMON]: [
    error.CLOUD_CONNECTOR_VERSION_WRONG,
    error.CLOUD_CONNECTOR_NOT_ACTIVE,
    error.CLOUD_CONNECTOR_USEDBY_OTHER,
    error.CLOUD_CONNECTOR_PAIRING_RSP_NOT_RECEIVED,
    error.CLOUD_CONNECTOR_INQUIRY_RSP_WRONG,
    error.CLOUD_CONNECTOR_INQUIRY_VEHICLE_ALREADY_UPDATED,
    error.CLOUD_CONNECTOR_INQUIRY_INVALID_TARGET_ECU,
    error.CLOUD_CONNECTOR_INQUIRY_RSP_NOT_RECEIVED,
    error.CLOUD_CONNECTOR_VEHICLE_COMMUNICATION_ERROR,
    error.CLOUD_CONNECTOR_INTERNAL_ERROR,
    error.CLOUD_CONNECTOR_USER_NOT_PAIRED,
    error.CLOUD_CONNECTOR_PFC_FILE_DOWNLOAD_FAILED,
    error.CLOUD_CONNECTOR_REPRO_EXECUTION_INPROGRESS,
    error.CLOUD_CONNECTOR_INVALID_J2534_DEVICE,
    error.CLOUD_CONNECTOR_SEQUENCE_APP_NOT_FOUND,
    error.CLOUD_CONNECTOR_SEQUENCE_APP_INIT_FAILED,
    error.CLOUD_CONNECTOR_REPRO_EXECUTE_FAILED,
    error.CLOUD_CONNECTOR_J2534_DEVICE_CRITICAL_ERROR,
    error.CLOUD_CONNECTOR_J2534_DEVICE_CONNECT_FAILED,
    error.CLOUD_CONNECTOR_DISCONNECT_NETWORK,
    error.CLOUD_CONNECTOR_READ_RXSWIN_FAILED,
    error.CLOUD_CONNECTOR_READ_RXSWIN_FAILED_2,
    error.CLOUD_CONNECTOR_UPDATE_RXSWIN_FAILED,
    error.CLOUD_CONNECTOR_UPDATE_RXSWIN_FAILED_2,
    error.CLOUD_CONNECTOR_READ_RXSWIN_FAILED_BEFORE_UPDATE,
  ],
  // 通信エラー
  [ERR_KEY.COMMUNICATION]: [],
  // 初期化通信エラー
  [ERR_KEY.INIT]: [],
  // STATUSエラー
  [ERR_KEY.STATUS]: [],
  // NRCエラー
  [ERR_KEY.NRC]: [],
  // 停止NRCエラー
  [ERR_KEY.STOP_NRC]: [],
};

/** エラータイプ */
export const ERR_TYPE = {
  /** 通信エラー */
  COMMUNICATE: "communicationError",
  /** STATUSエラー */
  STATUS: "statusError",
  /** NRCエラー */
  NRC: "nrcError",
};

/** 翻訳リソースやオブジェクトのキー */
export const PARAM = {
  ID: "active_test_id", // 不変ID
  SORT: "sort_id",
  ID_REQUIREMENT: "requirement_id", // 機能要求ID
  TITLE: "menu_title",
  TITLE_REF: "menu_title_ref",
  TITLE_ITEM: "item_name",
  DESCRIPT: "menu_description",
  DESCRIPT_REF: "menu_description_ref",
  FIELD: "fieldSpec",
  VAL: "value",
  VALS: "values",
  TITLE_ID: "title_id",
  CTRL_STATE: "control_state",
  DID: "did",
  DATA_MONITOR: "data_monitor"
};

/** 停止要求に対する処理結果 */
export const REQUEST_RESULT = {
  // 正常
  EXECUTE: 0,
  // 要求無効
  IGNORE: 1,
  // 処理中断
  ABORT: 2,
};

/** アクティブテストの状態定義 */
export const AT_EXE_TYPE = {
START: 0, //アクティブテスト駆動時
END: 1, //アクティブテスト停止時
ERROR: 2 //アクティブテストエラー時
};

export default {
  COMP_ERR,
  I18N_PARENT_ID,
  API_TYPE,
  FLOW,
  RES_TYPE,
  MNTR_STATUS,
  NRC_CODE,
  DATA_TYPE,
  ERR_KEY,
  ERR_KEY_CODE,
  ERR_TYPE,
  PARAM,
  REQUEST_RESULT,
  AT_EXE_TYPE
};
